import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/Bracket.css';
import App from './App';
import { AppProvider } from './context/AppContext';
import { AuthProvider } from './context/AuthContext';
import { BrowserRouter } from 'react-router-dom';

import { ErrorBoundary } from './components/common/ErrorBoundary';
import { db } from './firebaseConfig';
import { terminate, clearIndexedDbPersistence } from 'firebase/firestore';

// Initialize i18n
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const initializeApp = async () => {
  const CURRENT_VERSION = __APP_VERSION__;
  const storedVersion = localStorage.getItem('padel_app_version');

  if (storedVersion !== CURRENT_VERSION) {
    console.log(`Mise à jour de l'application : ${storedVersion || 'Inconnue'} -> ${CURRENT_VERSION}. Nettoyage du cache...`);
    try {
      // 1. Unregister all service workers
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const registration of registrations) {
          await registration.unregister();
        }
      }

      // 2. Clear all cache storage (PWA assets)
      if ('caches' in window) {
        const keys = await caches.keys();
        for (const key of keys) {
          await caches.delete(key);
        }
      }

      // 3. Clear Firestore offline persistence
      await terminate(db);
      await clearIndexedDbPersistence(db);

      // Save new version
      localStorage.setItem('padel_app_version', CURRENT_VERSION);

      console.log('Cache nettoyé avec succès. Redémarrage...');
      window.location.reload();
      return; // Stop execution to allow reload
    } catch (error) {
      console.error('Erreur lors du nettoyage du cache :', error);
      // Fallback: still set the version so we don't loop endlessly
      localStorage.setItem('padel_app_version', CURRENT_VERSION);
    }
  }

  // Normal render
  root.render(
    <React.StrictMode>
      <I18nextProvider i18n={i18n}>
        <ErrorBoundary>
          <BrowserRouter>
            <AuthProvider>
              <AppProvider>
                <App />
              </AppProvider>
            </AuthProvider>
          </BrowserRouter>
        </ErrorBoundary>
      </I18nextProvider>
    </React.StrictMode>
  );
};

initializeApp();